import { render, staticRenderFns } from "./PartSearchFacets.vue?vue&type=template&id=22aaaa72"
import script from "./PartSearchFacets.vue?vue&type=script&lang=js"
export * from "./PartSearchFacets.vue?vue&type=script&lang=js"
import style0 from "./PartSearchFacets.vue?vue&type=style&index=0&id=22aaaa72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports